export const ProfileModelConstants = {
  SUPERADMIN_ID: {
    ID: 1n,
  },
  ADMIN_ID: {
    ID: 2n,
  },
  READER_ID: {
    ID: 3n,
  },
  ADMIN_REGIONAL_ID: {
    ID: 4n,
  },
} as const
